import React from 'react'
import styled from 'styled-components'
import { BrandsCarouselProps } from './brandsCarousel.props'
import { Category } from './components'
import { Carousel } from '../Common'

export const BrandsCarousel = ({ data }: BrandsCarouselProps) => {
  return (
    <Container>
      <Carousel
        spaceBetweenSlides="1rem"
        slides={data}
        renderSlide={(item) => <Category data={item} />}
      />
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'container',
})``
